<script lang="ts">
	import PercentageChange from 'components/PercentageChange/PercentageChange.svelte';
	import ChartPreview from 'components/ChartPreview/ChartPreview.svelte';
	import type { IBaseCoinPriceData, ITableData } from '../types';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import activeCurrency from 'stores/activeCurrency';
	import formatNumber from 'utils/formatNumber';
	import formatCoinPrice from 'utils/formatCoinPrice';
	import PriceTooltip from 'components/PriceTooltip/PriceTooltip.svelte';

	export let data: ITableData;
	export let number: number;
	export let dark: boolean;
	export let isCustomCoin: boolean;
	export let coinPrice: number;
	export let symbol: string;
	export let exchangesBaseCoinPrice: IBaseCoinPriceData[];

	$: ({ exchange, liquidity, price, dayData, base, quote, chartVolumeData } = data);
	$: baseCoinPrice = exchangesBaseCoinPrice.find((item) => item.exchange === exchange)?.price;
	$: currencyData = $activeCurrency;
	$: isReverse = data.quote === symbol;
	$: reversePrice =
		currencyData.currency.toUpperCase() === symbol
			? baseCoinPrice / coinPrice || 1
			: baseCoinPrice || coinPrice;
</script>

<TableRow {dark} tableRowRef={null} class="coin-market-table-row" withHover={false}>
	<TableCell {dark} class="market-number">
		{number + 1}
	</TableCell>
	<TableCell {dark} class="market-market">
		<p class="pair">{`${base}/${quote}`}</p>
	</TableCell>
	<TableCell {dark} class="market-exchange">
		{exchange.toUpperCase()}
	</TableCell>
	<TableCell {dark} class="market-price">
		{#if price}
			<PriceTooltip
				price={formatCoinPrice(
					formatNumber(
						isReverse ? reversePrice : price * currencyData.price,
						currencyData.currency,
						price * currencyData.price > 1000000,
					),
				)}
			/>
		{:else}
			-
		{/if}
	</TableCell>
	<TableCell {dark} class="market-change-price">
		{#if dayData?.price_change}
			<PercentageChange
				{dark}
				dayChange={isCustomCoin ? dayData?.price_quote_change : Number(dayData?.price_change) * 100}
			/>
		{:else}
			<PercentageChange {dark} dayChange={0} />
		{/if}
	</TableCell>
	<TableCell {dark} class="market-volume">
		{#if dayData?.volume}
			{formatNumber(dayData.volume * currencyData.price, currencyData.currency, true)}
		{:else}
			-
		{/if}
	</TableCell>
	<TableCell {dark} class="market-change-volume">
		{#if dayData?.volume_change}
			<PercentageChange {dark} dayChange={Number(dayData.volume_change) * 100} />
		{:else}
			<PercentageChange {dark} dayChange={0} />
		{/if}
	</TableCell>
	<TableCell {dark} class="market-liquidity">
		{#if liquidity}
			{formatNumber(liquidity, null, liquidity > 99999999, 'decimal')}
		{:else}
			-
		{/if}
	</TableCell>
	<TableCell {dark} class="market-graph">
		{#if chartVolumeData && chartVolumeData.length > 1}
			<ChartPreview chartData={chartVolumeData} />
		{:else}
			<p class="no-data" class:dark>No data available</p>
		{/if}
	</TableCell>
</TableRow>

<style lang="scss">
	@import 'coinMarketTableRow';
</style>
